export default "__VITE_ASSET__CYEiexRp__"